import {EInputTextType, Input} from '../../../components/Input/Input';
import {FormattedMessage, injectIntl, useIntl} from 'react-intl';
import {withRouter} from 'react-router';
import {RootState} from '../../../reducers';
import {connect} from 'react-redux';
import React, {useEffect, useState} from 'react';
import {bindActionCreators, Dispatch} from 'redux';
import * as actions from '../../../actions/generalActions';
import * as adminActions from '../../../actions/admin';
import * as productActions from '../../../actions/production';
import '../admin.scss';
import PlusIconLink from '../../../assets/icons/plus.svg'
import {Button, EButtonType} from '../../../components/Button';
import MikaSelect from '../../../components/BbrosSelect/mikaSelect.component';
import {SelectOption} from '../../../types/selectOption.type';
import {axiosCaller} from '../../../utils/apiCaller';
import {ArticleInfomation} from '../../../types/ArticleInformation.type';
import {toast} from 'react-toastify';
import {t} from '../../../i18n';
import {
    checkCorrespondingInput,
    returnArrayWithValueLabelForSelect,
    setOnlyNewCorrespondingItems
} from "../globalFunctions";
import TableBbros from '../../../components/Table/TableBbros';
import {ARTICLE_COLUMNS, OPTIONS} from '../../../components/Table/TableConstants';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/DeleteOutline';
import {UnitsObj} from '../../../types/units.type';
import Tooltip from 'rc-tooltip';
import clearFormSvg from '../../../assets/icons/archeology.svg'
import ModalComponent from "../../../components/Modal/ModalComponent";
import Select from "react-select";
import * as transportActions from '../../../actions/transport'
import {setLoading} from "../../../actions/generalActions";
import {isMobile} from "../../../constants/constants";
import DeleteModalComponent from "../../../components/Modal/DeleteModal";

interface Props {
    history: any;
    actions: any;
    production: any;
    intl: any;
    admin: any
    adminActions: any;
    productActions: any;
    transport: any;
    transportActions: any;
    loading: boolean;
    articleTypes: SelectOption[],
    articles: ArticleInfomation[],
    unitsArticle: SelectOption[],
    units: SelectOption[],
    articlesForWarehouse: ArticleInfomation[]
    showSupply: any,
    buttonLoader: boolean,
    departments: SelectOption[]
}

const ArticleListAndCreateForm = (props: Props) => {
    const intl = useIntl();
    const fm = (id: string, defaultMessage: string) => intl.formatMessage({ id, defaultMessage });
    const [articleId, setArticleId] = useState<number>(null)
    const [articleName, setArticleName] = useState<string>('');
    const [productCode, setProductCode] = useState<string>('');
    const [dailyCapacity, setDailyCapacity] = useState<number>();
    const [extraTime, setExtraTime] = useState<number>();
    const [units, setUnits] = useState<SelectOption>({} as SelectOption);
    const [department, setDepartment] = useState<SelectOption>({} as SelectOption);
    const [supplier, setSupplier] = useState<SelectOption>({} as SelectOption);
    const [isInEditMode, setIsInEditMode] = useState(false);
    const [selectedArticleId, setSelectedArticleId] = useState();
    const [allUnits, setAllUnits] = useState([]);
    const [allSuppliers, setAllSuppliers] = useState([])
    const [forProduction, setForProduction] = useState<number>(1)
    const [responsibilityIds, setResponsibilityIds] = useState<number[]>([]);
    const [isWarehouseModalOpen, setIsWarehouseModalOpen] = useState<boolean>(false)
    const [selectedArticleForWarehouse, setSelectedArticleForWarehouse] = useState<SelectOption>()
    const [selectedAmountOfWarehouseProducts, setSelectedAmountOfWarehouseProducts] = useState<number>()
    const [order, setOrder] = useState<any[]>([])
    const [equipments, setEquipments] = useState<any[]>([])
    const [deliveryDays, setDeliveryDays] = useState<string>()
    const [equipmentOptions, setEquipmentOptions] = useState([])
    const [supplierCode, setSupplierCode] = useState('')
    const [isDeleteModalOpen, setDeleteModal] = useState<boolean>(false);
    const [image, setImage] = useState<File | null>(null);
    const [imagePreview, setImagePreview] = useState<string | null>(null);
    const [description, setDescription] = useState<string>('');
    const [pricePerUnit, setPricePerUnit] = useState<number | null>(null);
    const [costPerUnit, setCostPerUnit] = useState<number | null>(null);
    const [filterForProduction, setFilterForProduction] = useState<number | null>(null);
    const [filterDepartment, setFilterDepartment] = useState<SelectOption>({} as SelectOption);


    function buildFilterQuery(forProd: number | null, dept: SelectOption) {
        const params: string[] = [];
        if (forProd !== null) params.push(`forProduction=${forProd}`);
        if (dept?.value) params.push(`departmentId=${dept.value}`);
        return params.length ? `?${params.join('&')}` : undefined;
    }

    useEffect(() => {
        props.actions.fetchArticlesForWarehouse();
        props.actions.fetchUnits()
        props.actions.getAllDepartments()
        props.productActions.fetchResponsibilities();
        props.actions.fetchUnitsForArticle();
        props.adminActions.fetchMaterials();
        props.transportActions.fetchEquipments();
        props.adminActions.getSuppliers()
        axiosCaller('GET', `admin/articles/code`).then((res) => {
            setProductCode(res?.data)
        });
    }, []);

    useEffect(() => {
        props.actions.fetchArticles(buildFilterQuery(filterForProduction, filterDepartment));
    }, [filterForProduction, filterDepartment]);

    useEffect(() => {
        setEquipmentOptions(props?.transport?.equipments)
    }, [props?.transport?.equipments])

    useEffect(() => {
        if (articleId) {
            try {
                props.adminActions.fetchArticle(articleId);
            } catch (err) {
                toast.info(err);
            }
        } else {
            resetFields()
        }
    }, [articleId])

    useEffect(() => {
        setAllUnits(props.units)
    }, [props.units]);

    useEffect(() => {
        let tempArray = []

        props.admin?.suppliers?.forEach((supplier)=>{
            tempArray.push({label: supplier?.supplier, value: supplier?.id})
        })
        setAllSuppliers(tempArray)

    }, [props.admin.suppliers]);

    function saveArticle() {
        let materialsArray = []
        order.forEach((material, index) => {
            materialsArray.push(material.value)
        })
        let equipmentsArray = []
        equipments.forEach((equipment, index) => {
            equipmentsArray.push(equipment.value)
        })

        const formData = new FormData();
        formData.append('name', articleName);
        formData.append('productCode', productCode);
        formData.append('dailyCapacity', dailyCapacity ? String(dailyCapacity) : '');
        formData.append('extraTime', String(extraTime || 0));
        formData.append('unitId', String(units?.value !== undefined ? units?.value : units?.id));
        formData.append('forProduction', String(forProduction));
        formData.append('description', description || '');
        formData.append('pricePerUnit', pricePerUnit !== null && pricePerUnit !== undefined ? String(pricePerUnit) : '');
        formData.append('costPerUnit', costPerUnit !== null && costPerUnit !== undefined ? String(costPerUnit) : '');
        if (image) {
            formData.append('image', image);
        }
        if (department?.value) {
            formData.append('departmentId', String(department.value));
        }
        formData.append('deliveryDays', deliveryDays || '');
        responsibilityIds.forEach(id => formData.append('responsibilities[]', String(id)));
        materialsArray.forEach(m => formData.append('materials[]', String(m)));
        equipmentsArray.forEach(e => formData.append('equipments[]', String(e)));

        if (forProduction === 0) {
            formData.append('supplier[]', String(supplier?.value));
            formData.append('suppliersCode[0][code]', supplierCode || '');
        }

        if (articleName !== "" && productCode !== "" && (forProduction === 1 ? (dailyCapacity !== null && dailyCapacity !== 0) : true) && units?.value !== "" && (forProduction === 1 ? responsibilityIds.length !== 0 : true) && (forProduction === 1 ? order.length !== 0 : true) && (forProduction === 0 ? (deliveryDays != null && String(deliveryDays).length > 0) : true)) {
            isInEditMode ?
                props.adminActions.editArticle(selectedArticleId, formData).then((res) => {
                    if(res !== false){
                        props.actions.fetchArticles(buildFilterQuery(filterForProduction, filterDepartment));
                        props.actions.fetchArticlesForWarehouse();
                        resetFields()
                    }
                })
                :
                props.adminActions.createArticle(formData).then(() => {
                    props.actions.fetchArticles(buildFilterQuery(filterForProduction, filterDepartment));
                    props.actions.fetchArticlesForWarehouse();
                    axiosCaller('GET', `admin/articles/code`).then((res) => {
                        setProductCode(res?.data)
                    });
                    resetFields()
                })
        } else {
            toast.error(t('admin.articles.toastFillForm'))
        }
    }

    useEffect(() => {
        if (props.admin.articleInformation && articleId) {
            setArticleName(props.admin.articleInformation?.name);
            setUnits(props.admin.articleInformation.unit);
            setProductCode(props.admin.articleInformation?.productCode);
            setDailyCapacity(props.admin.articleInformation?.dailyCapacity);
            setDeliveryDays(props.admin.articleInformation?.deliveryDays)
            setExtraTime(props.admin.articleInformation?.extraTime)
            setForProduction(props.admin.articleInformation?.forProduction ? 1 : 0)
            setDepartment(props.admin.articleInformation?.department || {} as SelectOption)
            let tempArrayOfResponsibilityIds = []
            props.admin?.articleInformation?.responsibilities?.forEach((responsibility) => {
                tempArrayOfResponsibilityIds.push(JSON.stringify(responsibility.id))
            })
            setResponsibilityIds(tempArrayOfResponsibilityIds)
            setOrder(props.admin.articleInformation?.material)
            setEquipments(props.admin.articleInformation?.equipments)
            setSupplierCode(props.admin.articleInformation?.code[0]?.supplierCode)
            setSupplier({value:props.admin.articleInformation?.suppliers[0]?.id, label: props.admin.articleInformation?.suppliers[0]?.supplier})
            setDescription(props.admin.articleInformation?.description || '')
            setPricePerUnit(props.admin.articleInformation?.pricePerUnit ?? null)
            setCostPerUnit(props.admin.articleInformation?.costPerUnit ?? null)
            setImagePreview(props.admin.articleInformation?.image || null)
            setImage(null)
        } else {
            resetFields()
        }

    }, [props.admin.articleInformation]);

    function editArticleData(item: UnitsObj, method: string) {
        setArticleId(item?.value)
        setSelectedArticleId(item?.value);
        setIsInEditMode(method === 'edit');
    }

    const deleteArticle = () => {
        props.adminActions.deleteArticle(articleId).then(() => {
            props.actions.fetchArticles(buildFilterQuery(filterForProduction, filterDepartment));
            setDeleteModal(false)
            props.actions.fetchArticlesForWarehouse();
        });
    };

    const actions = [
        {
            icon: EditIcon,
            tooltip: fm('common.action.edit', 'Ndrysho'),
            onClick: (event: Event, rowData: UnitsObj) => editArticleData(rowData, 'edit')
        },
        {
            icon: DeleteIcon,
            tooltip: fm('common.action.delete', 'Fshi'),
            onClick: (event: Event, rowData: UnitsObj) => deleteButtonFunction(rowData)
        },
    ]

    function deleteButtonFunction (article) {
        setArticleId(article?.value)
        setDeleteModal(true)
    }

    function resetFields() {
        setArticleId(null)
        setDepartment({} as SelectOption)
        setArticleName('');
        setProductCode('');
        setDailyCapacity(null);
        setExtraTime(0)
        setUnits({
            label: '',
            value: undefined
        });
        setResponsibilityIds([])
        setIsInEditMode(false)
        setOrder([])
        setEquipments([])
        setImage(null)
        setImagePreview(null)
        setDescription('')
        setPricePerUnit(null)
        setCostPerUnit(null)
    }

    function addProductToWarehouse() {
        let payload = {
            articleId: selectedArticleForWarehouse?.value,
            quantity: selectedAmountOfWarehouseProducts
        }
        props.productActions.addArticlesToWarehouse(payload).then(() => {
            toast.success(t('admin.articles.warehouse.toastSuccess'))
        })
    }

    function returnIndexOfThatResponsibility(responsibilityIds, responsibility) {
        let tempIndex = ''
        responsibilityIds.forEach((responsibilityId, index) => {
            if (responsibilityId == responsibility.id) {
                tempIndex = `${index + 1}`
            }
        })
        return tempIndex
    }
    function setExtraTimeValue(value){
        if(value >= 0){
            setExtraTime(value)
        }
    }

    function setDailyCapacityValues(value){
        // if(value > 0){
        setDailyCapacity(value)
        // }
    }

    return (
        <div className="admin-page article-page">
            <div className="create-admin-page-form">
                <div className="input-container">
                    <Input
                        name="articleName"
                        value={articleName || ''}
                        type="text"
                        inputWrapperClass="col-12"
                        onChange={(name, value) => setArticleName(value)}
                        inputTextType={EInputTextType.SimpleInput}
                    >
                        <FormattedMessage id="admin.articles.field.name" defaultMessage="Emri i artikullit"/> *
                    </Input>
                    <div className="article-form-type-toggle">
                        <label className={`type-option ${forProduction === 1 ? 'active' : ''}`} htmlFor="forProduction">
                            <input type="radio" value={1} checked={forProduction === 1}
                                   onChange={(e) => setForProduction(Number(e.target.value))}
                                   name="forProduction" id="forProduction"/>
                            <FormattedMessage id="admin.articles.toggle.forProduction" defaultMessage="Për prodhim"/>
                        </label>
                        <label className={`type-option ${forProduction === 0 ? 'active' : ''}`} htmlFor="forWarehouse">
                            <input type="radio" value={0} checked={forProduction === 0}
                                   onChange={(e) => setForProduction(Number(e.target.value))}
                                   name="forProduction" id="forWarehouse"/>
                            <FormattedMessage id="admin.articles.toggle.forWarehouse" defaultMessage="I blerë"/>
                        </label>
                    </div>
                    <Input
                        name="productCode"
                        value={productCode || ''}
                        type="text"
                        inputWrapperClass="col-12"
                        onChange={(name, value) => setProductCode(value)}
                        inputTextType={EInputTextType.SimpleInput}
                    >
                        <FormattedMessage id="admin.articles.field.productCode" defaultMessage="Kodi i produktit"/> *
                    </Input>
                    <Input
                        name="pricePerUnit"
                        value={pricePerUnit ?? ''}
                        type="number"
                        inputWrapperClass="col-12"
                        onChange={(name, value) => setPricePerUnit(value !== '' ? Number(value) : null)}
                        inputTextType={EInputTextType.SimpleInput}
                    >
                        <FormattedMessage id="admin.articles.field.pricePerUnit" defaultMessage="Çmimi për njësi"/>
                    </Input>
                    <Input
                        name="costPerUnit"
                        value={costPerUnit ?? ''}
                        type="number"
                        inputWrapperClass="col-12"
                        onChange={(name, value) => setCostPerUnit(value !== '' ? Number(value) : null)}
                        inputTextType={EInputTextType.SimpleInput}
                    >
                        <FormattedMessage id="admin.articles.field.costPerUnit" defaultMessage="KMSH (Kosto e Mallit të Shitur)"/>
                    </Input>

                    {forProduction === 0 && <Input
                        name="deliveryDays"
                        value={deliveryDays || ''}
                        type="text"
                        inputWrapperClass="col-12"
                        onChange={(name, value) => setDeliveryDays(value)}
                        inputTextType={EInputTextType.SimpleInput}
                    >
                        <FormattedMessage id="admin.articles.field.deliveryDays" defaultMessage="Ditët e liferimit"/> *
                    </Input>}
                    {forProduction === 0 && <div className='position-relative'>
                        <MikaSelect
                            options={allSuppliers}
                            value={supplier || {} as SelectOption}
                            idRequired
                            setEntireOptionFunction={setSupplier}
                            placeholder={fm('admin.articles.field.supplier', 'Furnitori')}
                            selectWrapperClassName="my-3">
                            <FormattedMessage id="admin.articles.field.supplier" defaultMessage="Furnitori"/> *
                        </MikaSelect>
                        <Input
                            name="deliveryDays"
                            value={supplierCode || ''}
                            type="text"
                            inputWrapperClass="col-12"
                            onChange={(name, value) => setSupplierCode(value)}
                            inputTextType={EInputTextType.SimpleInput}
                        >
                            <FormattedMessage id="admin.articles.field.supplierCode" defaultMessage="Kodi i furnitorit"/>
                        </Input>
                    </div>}

                    <MikaSelect
                        options={allUnits}
                        value={units || {} as SelectOption}
                        idRequired
                        setEntireOptionFunction={setUnits}
                        placeholder={fm('admin.articles.field.unit', 'Njësia')}
                        selectWrapperClassName="my-3">
                        <FormattedMessage id="admin.articles.field.unit" defaultMessage="Njësia"/> *
                    </MikaSelect>

                    {forProduction === 1 && <MikaSelect
                        options={props?.departments}
                        value={department || {} as SelectOption}
                        idRequired
                        setEntireOptionFunction={setDepartment}
                        placeholder={fm('admin.articles.field.department', 'Reparti')}
                        selectWrapperClassName="my-3">
                        <FormattedMessage id="admin.articles.field.department" defaultMessage="Reparti"/>
                    </MikaSelect>}

                    {forProduction === 1 && <Input
                        name="dailyCapacity"
                        value={dailyCapacity || ''}
                        type="number"
                        inputWrapperClass="col-12"
                        min={1}
                        onChange={(name, value) => setDailyCapacityValues(value)}
                        inputTextType={EInputTextType.SimpleInput}>
                        <FormattedMessage id="admin.articles.field.dailyCapacity" defaultMessage="Kapaciteti ditor"/> *
                    </Input>}

                    {forProduction === 1 && <Input
                        name="extraTimeInPercentage"
                        value={extraTime || ''}
                        type="number"
                        inputWrapperClass="col-12"
                        onChange={(name, value) => setExtraTimeValue(value)}
                        inputTextType={EInputTextType.SimpleInput}>
                        <FormattedMessage id="admin.articles.field.extraTime" defaultMessage="Hapësirë kohore ekstra (%)"/>
                    </Input>}
                    {forProduction === 1 && <Select
                        id="order"
                        name="order"
                        options={props.admin.materials}
                        closeMenuOnSelect={false}
                        className={order && order ? "select-input material-select my-3 w-100 input-error" : "select-input material-select my-3 w-100"}
                        classNamePrefix="react-select"
                        isMulti
                        value={order || ''}
                        onChange={(value: any) => setOrder(value)}
                        placeholder={fm('admin.articles.field.materials', 'Materialet')}/>}
                    {forProduction === 1 && <Select
                        id="equipments"
                        name="quipments"
                        options={equipmentOptions}
                        closeMenuOnSelect={false}
                        className={equipments && equipments ? "select-input material-select my-3 w-100 input-error" : "select-input material-select my-3 w-100"}
                        classNamePrefix="react-select"
                        isMulti
                        value={equipments || ''}
                        onChange={(value: any) => setEquipments(value)}
                        placeholder={fm('admin.articles.field.equipments', 'Pajisjet')}/>}
                    <div className="article-image-upload" onClick={() => (document.getElementById('articleImageInput') as HTMLInputElement)?.click()}>
                        {imagePreview ? (
                            <>
                                <img src={imagePreview} alt="article preview"/>
                                <button className="image-remove-btn" onClick={(e) => { e.stopPropagation(); setImage(null); setImagePreview(null); }}>×</button>
                            </>
                        ) : (
                            <div className="upload-placeholder">
                                <span className="upload-plus">+</span>
                                <p><FormattedMessage id="admin.articles.field.image" defaultMessage="Foto e artikullit"/></p>
                            </div>
                        )}
                        <input id="articleImageInput" type="file" accept="image/*" style={{display: 'none'}}
                            onChange={(e) => {
                                const file = e.target.files?.[0] || null;
                                setImage(file);
                                setImagePreview(file ? URL.createObjectURL(file) : null);
                            }}
                        />
                    </div>
                    <div className="article-description-wrapper">
                        <label><FormattedMessage id="admin.articles.field.description" defaultMessage="Përshkrimi i artikullit"/></label>
                        <textarea
                            className="article-description-textarea"
                            rows={3}
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            placeholder="..."
                        />
                    </div>
                    <Button
                        isLoading={props?.buttonLoader}
                        isDisabled={props?.buttonLoader}
                        submit={true}
                        className="w-100 mt-5"
                        buttonType={EButtonType.GreyButton}
                        onClick={saveArticle}>
                        {articleId ?
                            <FormattedMessage id="admin.articles.btnEdit" defaultMessage="Edito këtë artikull"/>
                            :
                            <FormattedMessage id="admin.articles.btnCreate" defaultMessage="Krijo artikullin"/>
                        }
                    </Button>
                    <Button
                        isLoading={props?.buttonLoader}
                        isDisabled={props?.buttonLoader}
                        className="w-100 mt-5"
                        buttonType={EButtonType.GreyButton}
                        onClick={() => setIsWarehouseModalOpen(true)}>
                        <FormattedMessage id="admin.articles.btnAddToWarehouse" defaultMessage="Shto produkt në depo"/>
                    </Button>
                </div>
            </div>

            {forProduction === 1 && <div className={`responsibilityListContainer ${isMobile ? 'w-100' : ''}`}>
                <p><FormattedMessage id="admin.articles.responsibilitiesTitle" defaultMessage="Lista e proceseve"/> *</p>
                <div className="responsibilities-container">
                    {props.production.responsibilities && props.production.responsibilities.map((responsibility, index) => {
                        return (
                            <div className="responsibility" key={index}>
                                <Input
                                    id={`input` + responsibility?.label}
                                    name={responsibility?.label}
                                    value={responsibility?.id}
                                    type="checkbox"
                                    inputWrapperClass="checkboxWrapper"
                                    valueNeedeed
                                    checked={checkCorrespondingInput(responsibilityIds, responsibility)}
                                    onChange={(currentTarget) => setOnlyNewCorrespondingItems(currentTarget.checked, currentTarget.value, setResponsibilityIds, responsibilityIds)}
                                >
                                    {returnIndexOfThatResponsibility(responsibilityIds, responsibility) &&
                                    <p className={'index'}>{returnIndexOfThatResponsibility(responsibilityIds, responsibility)}</p>}
                                    <p className="m-0">{responsibility?.label}</p>
                                </Input>
                            </div>
                        )
                    })}
                </div>
            </div>}

            <div className="admin-page-list">
                <h2 className="m-0 mb-4">
                    <FormattedMessage id="admin.articles.listTitle" defaultMessage="Lista e artikujve"/>
                    <Tooltip placement="right" overlay={<span><FormattedMessage id="admin.articles.clearForm" defaultMessage="Pastro formën"/></span>}>
                        <img className="create-client-icon" onClick={resetFields} src={clearFormSvg}
                             alt="create client"/>
                    </Tooltip>
                </h2>
                <div className="article-list-filters">
                    <div className="article-form-type-toggle">
                        <label className={`type-option ${filterForProduction === null ? 'active' : ''}`}>
                            <input type="radio" name="filterForProduction" checked={filterForProduction === null}
                                   onChange={() => setFilterForProduction(null)}/>
                            <FormattedMessage id="admin.articles.filterAll" defaultMessage="Të gjitha"/>
                        </label>
                        <label className={`type-option ${filterForProduction === 1 ? 'active' : ''}`}>
                            <input type="radio" name="filterForProduction" checked={filterForProduction === 1}
                                   onChange={() => setFilterForProduction(1)}/>
                            <FormattedMessage id="admin.articles.toggle.forProduction" defaultMessage="Për prodhim"/>
                        </label>
                        <label className={`type-option ${filterForProduction === 0 ? 'active' : ''}`}>
                            <input type="radio" name="filterForProduction" checked={filterForProduction === 0}
                                   onChange={() => setFilterForProduction(0)}/>
                            <FormattedMessage id="admin.articles.toggle.forWarehouse" defaultMessage="I blerë"/>
                        </label>
                    </div>
                    <MikaSelect
                        options={[{label: fm('admin.articles.filterAllDepartments', 'Të gjitha repartet'), value: null}, ...(props.departments || [])]}
                        value={filterDepartment}
                        setEntireOptionFunction={setFilterDepartment}
                        placeholder={fm('admin.articles.filterAllDepartments', 'Të gjitha repartet')}
                        selectWrapperClassName="mt-2"
                    />
                </div>
                <TableBbros
                    title={fm('admin.articles.tableTitle', 'Artikulli')}
                    data={props.articles}
                    columns={ARTICLE_COLUMNS}
                    options={OPTIONS}
                    actions={actions}
                    isLoading={props.loading}
                />
            </div>
            <ModalComponent
                isModalHeader
                isOpen={isWarehouseModalOpen}
                close={() => setIsWarehouseModalOpen(false)}
            >
                <div className={'w-100 px-3'}>
                    <div className={'warehouseModal-header'}>
                        <p><FormattedMessage id="admin.articles.warehouse.title" defaultMessage="Shto produkt në depo"/></p>
                    </div>
                    <div className={'warehouseModal-content d-flex align-items-center justify-content-between'}>
                        <MikaSelect selectWrapperClassName={'w-50 p-1'}
                                    options={props.articlesForWarehouse}
                                    value={selectedArticleForWarehouse}
                                    setEntireOptionFunction={setSelectedArticleForWarehouse}
                        >
                            <FormattedMessage id="admin.articles.warehouse.selectProduct" defaultMessage="Zgjidh produktin për depo"/>
                        </MikaSelect>
                        <Input
                            name="comments"
                            label="label"
                            id="comments"
                            value={selectedAmountOfWarehouseProducts || ''}
                            defaultValue=''
                            onChange={(name, value) => setSelectedAmountOfWarehouseProducts(value)}
                            type="number"
                            inputWrapperClass="w-50 p-1"
                            inputTextType={EInputTextType.SimpleInput}
                        >
                            <p className={'mb-1'}><FormattedMessage id="admin.articles.warehouse.amount" defaultMessage="Sasia e produkteve për depo"/></p>
                        </Input>
                    </div>
                    <div className={'d-flex justify-content-end align-items-center'}>
                        <Button
                            isLoading={props?.buttonLoader}
                        isDisabled={props?.buttonLoader}
                            className="w-100 mt-5"
                            buttonType={EButtonType.GreyButton}
                            onClick={addProductToWarehouse}>
                            <FormattedMessage id="admin.articles.btnAddToWarehouse" defaultMessage="Shto produkt në depo"/>
                        </Button>
                    </div>
                </div>
            </ModalComponent>
            <ModalComponent
                isModalHeader
                isOpen={isDeleteModalOpen}
                close={setDeleteModal}
            >
                <DeleteModalComponent
                    history={props.history}
                    close={() => setDeleteModal(false)}
                    deleteFunction={() => deleteArticle()} />
            </ModalComponent>
        </div>
    );
};

function mapGlobalStateToProps(state: RootState, ownProps: any) {
    return {
        ...ownProps,
        ...state.app,
        transport: state.transport,
        admin: state.admin,
        production: state.production,
    };
}

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
    return {
        actions: bindActionCreators(actions as any, dispatch),
        adminActions: bindActionCreators(adminActions as any, dispatch),
        productActions: bindActionCreators(productActions as any, dispatch),
        transportActions: bindActionCreators(transportActions as any, dispatch)
    };
}

export default withRouter(connect(mapGlobalStateToProps, mapDispatchToProps)(injectIntl(ArticleListAndCreateForm as any)));
